import * as Yup from 'yup'
import { filter } from 'lodash';
import { Icon } from '@iconify/react';
import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  CircularProgress,
  Grid,
  TextField,
  Box,
  Autocomplete,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
// redux
import { useDispatch } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import SearchNotFound from '../../components/SearchNotFound';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserMoreMenu } from '../../components/_dashboard/user/list';
import plusFill from '@iconify/icons-eva/plus-fill';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT } from '../../constants/Defaultvalues';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import Label from 'src/components/Label';
import { sentenceCase } from 'change-case';
import moment from 'moment';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { Form, FormikProvider, useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@material-ui/lab';
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'ID', alignRight: false },
  { id: 'qb', label: 'qb', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  // { id: 'value', label: 'Billing Type', alignRight: false },
  { id: '', label: '', alignRight: false },
];

function scrollCustomerTypePaginationToTop(anchorEl, tableScrollBoxEl, tableContainerEl) {
  if (typeof window === 'undefined') return
  const { documentElement, body } = document
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  documentElement.scrollTop = 0
  body.scrollTop = 0

  let el = anchorEl
  while (el) {
    const { overflowY } = window.getComputedStyle(el)
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight
    ) {
      el.scrollTop = 0
    }
    el = el.parentElement
  }

  const scrollBox = tableScrollBoxEl
  if (scrollBox) {
    scrollBox.scrollTop = 0
    if (typeof scrollBox.scrollTo === 'function') {
      scrollBox.scrollTo({
        top: 0,
        left: scrollBox.scrollLeft,
        behavior: 'auto',
      })
    }
  }
  const tableWrap = tableContainerEl
  if (tableWrap) {
    const left = tableWrap.scrollLeft
    tableWrap.scrollTop = 0
    if (typeof tableWrap.scrollTo === 'function') {
      tableWrap.scrollTo({ top: 0, left, behavior: 'auto' })
    }
  }
}

// ----------------------------------------------------------------------

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

function descendingComparator(a, b, orderBy) {
  const aValue = a[orderBy] ? a[orderBy].toString() : '';
  const bValue = b[orderBy] ? b[orderBy].toString() : '';
  return bValue.localeCompare(aValue, undefined, { sensitivity: 'base' });
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const TaxType = [
  { name : '%', id : 1},
  { name : '$', id : 2},
]

export default function CustomerType(props) {
  const theme = useTheme();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar()
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions = userData?.exploded_permissions
  const userId = userData.user_id
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const location = useLocation();
  const receivedData = location.state?.data;
  const [taxCategories, setTaxCategories] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editId, setEditId] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [openDeletePop, setOpenDeletePop] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [deletingName, setDeletingName] = useState('');
  const [openCloseConfirm, setOpenCloseConfirm] = useState(false);
  const tableContainerRef = useRef(null);
  const tableScrollBoxRef = useRef(null);
  const paginationScrollAnchorRef = useRef(null);
  const skipPaginationScrollRef = useRef(true);

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  const fetchTaxCategory = async () => {
    setLoading(true)
    try{
        const response = await axios.post(`${REST_API_END_POINT}customer-type/get-all-customer-type`)
        if(response.data.status === 1){
            setTaxCategories(response.data.result);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
    finally{
        setLoading(false)
    }
  }

  useEffect(()=>{
      fetchTaxCategory()
  },[refreshData])

  const handleDeleteClick = async (id, newStatus) => {
    setDeletingName('');
    setDeletingId(null);
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
  }

  const handleMenuClick = async (id, status) => {
    let newStatus;
    (status === 1) ? newStatus = 0 : newStatus = 1
    await changeStatus(id, newStatus);
  }
  
  const handleEdit = async (id) => {
    setEditId(id)
    try{
      const response = await axios.post(`${REST_API_END_POINT}customer-type/get-customer-type`,{id})
      if(response.data.status === 1){
          setEditData(response.data.result);
          setOpenModel(true);
      }else{
        setEditId(null);
        setEditData(null);
      }
    }catch(error){
      console.log("Error - ",error);
      setEditId(null);
      setEditData(null);
    }
  }
  const changeStatus = async (comId, comStatus) => {
    try {
      let deleteId = comId;
      let status = comStatus;
      let response = await axios.post(`${REST_API_END_POINT}customer-type/delete-customer-type`,{deleteId,status,userId});
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        setRefreshData(!refreshData)
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
        setRefreshData(!refreshData)
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Server Error...!", { variant: 'error' });
        setRefreshData(!refreshData)
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useLayoutEffect(() => {
    if (skipPaginationScrollRef.current) {
      skipPaginationScrollRef.current = false
      return
    }
    const run = () =>
      scrollCustomerTypePaginationToTop(
        paginationScrollAnchorRef.current,
        tableScrollBoxRef.current,
        tableContainerRef.current
      )
    run()
    requestAnimationFrame(() => {
      requestAnimationFrame(run)
    })
  }, [page, rowsPerPage])

  const tableMaxHeight = useTableMaxHeight(
    tableScrollBoxRef,
    [loading, taxCategories?.length, rowsPerPage, filterName]
  );

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const NewUserSchema = Yup.object()
    .shape({
      name: Yup.string().required('Name is required').nullable(),
      paymentType: Yup.string().required('Please select a payment terms type'),
      afterDays: Yup.string()
        .nullable()
        .matches(/^(\d{1,3})?$/, 'Days must be up to 3 digits')
        .when('paymentType', {
          is: 'days',
          then: (schema) => schema.required('Days is required for After Days'),
        }),
      paymentDays: Yup.string()
        .nullable()
        .matches(/^(\d{1,3})?$/, 'Days must be up to 3 digits')
        .when('paymentType', {
          is: 'months_days',
          then(schema) {
            return schema.test(
              'at-least-one-months-days',
              'Enter Months and/or Days for Months / Days',
              function (value) {
                const { paymentMonths } = this.parent;
                return !!(value || paymentMonths);
              }
            );
          },
        }),
      paymentMonths: Yup.string()
        .nullable()
        .matches(/^(\d{1,2})?$/, 'Months must be up to 2 digits')
        .when('paymentType', {
          is: 'months_days',
          then(schema) {
            return schema.test(
              'at-least-one-months-days',
              'Enter Months and/or Days for Months / Days',
              function (value) {
                const { paymentDays } = this.parent;
                return !!(value || paymentDays);
              }
            );
          },
        }),
    });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editData?.name || '',
      billingType: editData?.billing_type || 0,
      quickbookId: editData?.quickbookId || null,
      paymentType: editData?.payment_type || 'days',
      afterDays:
        typeof editData?.payment_days_only === 'number' && !Number.isNaN(editData?.payment_days_only)
          ? String(editData?.payment_days_only)
          : '',
      paymentDays:
        typeof editData?.payment_days === 'number' && !Number.isNaN(editData?.payment_days)
          ? String(editData?.payment_days)
          : '',
      paymentMonths:
        typeof editData?.payment_months === 'number' && !Number.isNaN(editData?.payment_months)
          ? String(editData?.payment_months)
          : '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const payloadValues = { ...values };

        if (values.paymentType === 'days') {
          payloadValues.paymentMonths = '';
          payloadValues.paymentDays = '';
        }
        if (values.paymentType === 'months_days') {
          payloadValues.afterDays = '';
        }

        const response = await axios.post(
          REST_API_END_POINT + (editId ? 'customer-type/update-customer-type' : 'customer-type/add-customer-type'),
          { values: payloadValues, userId, editId }
        )
        let data = response.data;
        resetForm();
        setSubmitting(false);
        setRefreshData(!refreshData);
        setOpenModel(false);
        enqueueSnackbar(`${data.message}`, { variant: data.status === 1 ? 'success' : 'error' });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(`Server Error`, { variant: 'error' });
      }
    }
  });

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  const isAfterDaysActive = values.paymentType === 'days';
  const isMonthsDaysActive = values.paymentType === 'months_days';

  const handleCloseConfirmYes = async () => {
    setOpenCloseConfirm(false);
    try {
      await formik.submitForm();
    } catch (error) {
      console.error('Auto-save failed:', error);
      setOpenModel(false);
      setEditId(null);
      setEditData(null);
      formik.resetForm();
    }
  };

  const handleCloseConfirmNo = () => {
    setOpenCloseConfirm(false);
    setOpenModel(false);
    setEditId(null);
    setEditData(null);
    formik.resetForm();
  };

  const handleModalCancel = () => {
    setOpenModel(false);
    setEditId(null);
    setEditData(null);
    formik.resetForm();
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - taxCategories.length) : 0;
  const filteredUsers = applySortFilter(taxCategories, getComparator(order, orderBy), filterName);
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title={`Payment Terms | ${COMPANY_NAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs
            heading="Payment Terms"
          />
          <Box>
            {/* <Button
              // disabled={explodedPermissions?.some(permission => ['Add Catalog'].includes(permission)) ? false : true}
              sx={{mr:2}}
              onClick={()=>{
                setEditId(null)
                 setOpenModel(true);
                 setFieldValue('billingType', 0);
                 setFieldValue('name', '');
                 setFieldValue('paymentType', 'days');
                 setFieldValue('afterDays', '');
                 setFieldValue('paymentDays', '');
                 setFieldValue('paymentMonths', '');

                 }}
              variant="contained"
              startIcon={<Icon icon={plusFill} />}
            > Add New </Button> */}
          </Box>
        </Stack>
        {/* <Stack direction="row" alignItems="center" justifyContent="center" sx={{mb:3}}>
            <Stack sx={{py:0.5,px:2,borderRadius:2,backgroundColor:theme.palette.error.main}}>
                <Typography sx={{color:theme.palette.text.primary}}>Please contact super admin to update tax categories</Typography>
            </Stack>
        </Stack> */}
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Card>
                  <Stack direction="row" alignItems="center">
                <MaterialInventoryToolbar
                filterName={filterName} 
                onFilterName={handleFilterByName}
                item="Payment Terms"
                />
                <Typography variant="body2" sx={{ color: '#40c817' }}>
                 Payment Terms are fetched from QuickBooks.
                </Typography>
                </Stack>
                <Box ref={paginationScrollAnchorRef}>
                <Box
                  ref={tableScrollBoxRef}
                  sx={{
                    maxHeight: tableMaxHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    width: '100%',
                    '&::-webkit-scrollbar': {
                      width: '0.6em',
                      height: '0.6em',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#1e1e1e',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#555',
                      borderRadius: '6px',
                      border: '2px solid #1e1e1e',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#888',
                    },
                    '&::-webkit-scrollbar-corner': {
                      backgroundColor: '#1e1e1e',
                    },
                  }}
                >
                    <TableContainer
                      ref={tableContainerRef}
                      sx={{
                        minWidth: 500,
                        whiteSpace: 'nowrap',
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                          width: '0.6em',
                          height: '0.6em',
                        },
                        '&::-webkit-scrollbar-track': {
                          background: '#1e1e1e', // dark background to blend with dark UI
                          borderRadius: '4px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#555', // medium-gray thumb
                          borderRadius: '6px',
                          border: '2px solid #1e1e1e', // contrast border to separate from track
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                          backgroundColor: '#888', // lighter on hover for feedback
                        },
                        '&::-webkit-scrollbar-corner': {
                          backgroundColor: '#1e1e1e' // match your dark background
                        },
                      }}
                    >
                    <Table 
                      stickyHeader
                      sx={{
                        '& .MuiTableCell-head': {
                          padding: '8px 12px',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          height: '48px',
                          minHeight: '48px',
                          maxHeight: '48px',
                          lineHeight: 1.4,
                          whiteSpace: 'nowrap',
                          textAlign: 'left',
                          verticalAlign: 'middle'
                        },
                        '& .MuiTableSortLabel-root': {
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          justifyContent: 'flex-start',
                          '& .MuiTableSortLabel-icon': {
                            marginLeft: '4px'
                          }
                        }
                      }}
                    >
                    <UserListHead
                        order={order}
                        orderBy={orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={slicedData?.length}
                        onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                        {loading ? (
                            <CircularProgress color="primary" variant="indeterminate" />
                            ) : (
                            <>
                        {slicedData?.map((row) => {
                            let { id,name, billing_type, quickbookId } = row;
                            let statusText = (status === 1) ? "Active" : "Inactive";
                            return (
                            <TableRow
                                hover
                                key={id}
                                tabIndex={-1}
                                sx={{
                                  '& .MuiTableCell-root': {
                                    padding: '8px 12px',
                                    fontSize: '0.75rem',
                                    height: 'auto',
                                    lineHeight: 1.4
                                  }
                                }}
                            >
                                <TableCell padding="checkbox" sx={{ padding: '8px 4px !important', width: '40px' }}>
                                {/* <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, id,name)} /> */}
                                </TableCell>
                                {/* <TableCell align="left" sx={{ padding: '8px 12px' }}>{id}</TableCell> */}
                                <TableCell align="left" sx={{ padding: '8px 12px' }}><Avatar src={QbLogo} sx={{ width: 30, height: 30, objectFit: "cover", display: quickbookId ? 'flex' : 'none' }} alt='qb' /></TableCell>
                                <TableCell component="th" scope="row" align="left" sx={{ padding: '8px 12px' }}>
                                  <Tooltip title={name}>
                                    <Typography 
                                      variant="subtitle2" 
                                      noWrap 
                                      // onClick={()=>{navigate(`${PATH_DASHBOARD.products.editMaterial}?id=${id}/edit`)}} 
                                      sx={{ 
                                        cursor: 'pointer',
                                        maxWidth: 200,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontSize: '0.75rem',
                                        fontWeight: 500
                                      }}
                                    >
                                      {name}
                                    </Typography>
                                  </Tooltip>
                                </TableCell>
                                {/* <TableCell align="left" sx={{ padding: '8px 12px' }}>{billing_type}</TableCell>*/}
                                
                                {/* <TableCell align="right" sx={{ padding: '8px 12px' }}>
                                  <UserMoreMenu
                                    onDelete={()=>{setOpenDeletePop(true);setDeletingId(id);setDeletingName(name);}}
                                    onEdit={()=>{ handleEdit(id) }} 
                                />
                              </TableCell> */}
                            </TableRow>
                            );
                        })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                            </TableRow>
                        )}
                        </>
                            )}
                        </TableBody>
                        {isUserNotFound && (
                        <TableBody>
                            <TableRow>
                            <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                <SearchNotFound searchQuery={filterName} msg="Payment Terms"/>
                            </TableCell>
                            </TableRow>
                        </TableBody>
                        )}
                    </Table>
                    </TableContainer>
                </Box>

                <TablePagination
                    rowsPerPageOptions={[25, 50, 100, 500]}
                    component="div"
                    count={taxCategories.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                </Box>
                </Card>
            </Grid>
        </Grid>
      </Container>
      <Modal
        modalTitle={editId ? 'Edit Payment Terms' : 'Add Payment Terms'}
        open={openModel}
        handleClose={() => setOpenCloseConfirm(true)}
      >
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={8}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                        fullWidth
                        label={'Name'}
                        {...getFieldProps('name')}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                    />
                    <FormControl component="fieldset">
                      <FormLabel component="legend">Payment Terms</FormLabel>
                    </FormControl>
                    <Stack direction="row" alignItems="flex-start" spacing={4}>
                      <Stack direction="column" spacing={1} sx={{ minWidth: 200 }}>
                        <Stack direction="column" spacing={1} sx={{ minWidth: 260 }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Radio
                              checked={isAfterDaysActive}
                              onChange={() => setFieldValue('paymentType', 'days')}
                              value="days"
                              name="paymentType"
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                color: isAfterDaysActive
                                  ? theme.palette.text.primary
                                  : theme.palette.text.disabled,
                                opacity: isAfterDaysActive ? 1 : 0.5,
                              }}
                            >
                              After Days
                            </Typography>
                          </Stack>
                          <TextField
                            fullWidth
                            label="Days"
                            type="tel"
                            value={values.afterDays || ''}
                            onChange={(event) => {
                              let { value } = event.target;
                              value = value.replace(/\D/g, '');
                              if (value.length > 3) {
                                value = value.slice(0, 3);
                              }
                              setFieldValue('afterDays', value);
                            }}
                            inputProps={{ maxLength: 3 }}
                            disabled={!isAfterDaysActive}
                            sx={{
                              opacity: isAfterDaysActive ? 1 : 0.4,
                              '& .MuiInputBase-input.Mui-disabled': {
                                WebkitTextFillColor: theme.palette.text.disabled,
                              },
                            }}
                            error={Boolean(touched.afterDays && errors.afterDays)}
                            helperText={touched.afterDays && errors.afterDays}
                          />
                        </Stack>

                        <Stack spacing={1}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Radio
                              checked={isMonthsDaysActive}
                              onChange={() => setFieldValue('paymentType', 'months_days')}
                              value="months_days"
                              name="paymentType"
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                color: isMonthsDaysActive
                                  ? theme.palette.text.primary
                                  : theme.palette.text.disabled,
                                opacity: isMonthsDaysActive ? 1 : 0.5,
                              }}
                            >
                              After Months / Days
                            </Typography>
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TextField
                              fullWidth
                              label="Months"
                              type="tel"
                              value={values.paymentMonths || ''}
                              onChange={(event) => {
                                let { value } = event.target;
                                value = value.replace(/\D/g, '');
                                if (value.length > 2) {
                                  value = value.slice(0, 2);
                                }
                                setFieldValue('paymentMonths', value);
                              }}
                              inputProps={{ maxLength: 2 }}
                              disabled={!isMonthsDaysActive}
                              sx={{
                                opacity: isMonthsDaysActive ? 1 : 0.4,
                                '& .MuiInputBase-input.Mui-disabled': {
                                  WebkitTextFillColor: theme.palette.text.disabled,
                                },
                              }}
                              error={Boolean(touched.paymentMonths && errors.paymentMonths)}
                              helperText={touched.paymentMonths && errors.paymentMonths}
                            />
                            <TextField
                              fullWidth
                              label="Days"
                              type="tel"
                              value={values.paymentDays || ''}
                              onChange={(event) => {
                                let { value } = event.target;
                                value = value.replace(/\D/g, '');
                                if (value.length > 3) {
                                  value = value.slice(0, 3);
                                }
                                setFieldValue('paymentDays', value);
                              }}
                              inputProps={{ maxLength: 3 }}
                              disabled={!isMonthsDaysActive}
                              sx={{
                                opacity: isMonthsDaysActive ? 1 : 0.4,
                                '& .MuiInputBase-input.Mui-disabled': {
                                  WebkitTextFillColor: theme.palette.text.disabled,
                                },
                              }}
                              error={Boolean(touched.paymentDays && errors.paymentDays)}
                              helperText={touched.paymentDays && errors.paymentDays}
                            />
                          </Stack>
                        </Stack>
                      </Stack>

                    </Stack>
                     {/* <TextField
                    fullWidth
                    label="Billing Type (%)"
                    type="tel"
                    {...getFieldProps('billingType')}
                    onKeyDown={(event) => {
                      // List of allowed keys: Numbers (0-9), Backspace, Delete, ArrowLeft, ArrowRight
                      const allowedKeys = [
                        'Backspace',       // Backspace for deletion
                        'Delete',          // Delete key for removing
                        'ArrowLeft',       // Left arrow for cursor movement
                        'ArrowRight',      // Right arrow for cursor movement
                        'Tab',             // Tab for navigation (optional)
                        '.',               // Decimal point (only one allowed)
                        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'  // Numeric keys 0-9
                      ];

                      // If the pressed key is not in the allowed list, prevent its default behavior
                      if (!allowedKeys.includes(event.key)) {
                        event.preventDefault();  // Block invalid keys (special characters and letters)
                      }

                      // Allow only one decimal point
                      if (event.key === '.' && event.target.value.includes('.')) {
                        event.preventDefault(); // Prevent entering more than one decimal point
                      }
                    }}
                    InputProps={{
                        endAdornment: "%"
                    }}
                    onChange={(event) => {
                      let value = event.target.value;

                      // If the input contains more than one decimal point, remove the extra one
                      if (value.split('.').length > 2) {
                        value = value.slice(0, -1); // Remove the last character if multiple decimal points exist
                      }

                      if (value.includes('.')) {
                        const [integerPart, decimalPart] = value.split('.');
                        value = decimalPart.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : value;
                      }

                      if(value > 100){
                        value = 100
                      }

                      // Update the value in Formik
                      setFieldValue('billingType', value);
                    }}
                    error={Boolean(touched.billingType && errors.billingType)}
                    helperText={touched.billingType && errors.billingType}
                  /> */}
                    {/* <Autocomplete
                      fullWidth
                      options={TaxType || []}
                      value={values.type}
                      onChange={(event, newValue) => {
                        setFieldValue('type', newValue);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} required
                          error={Boolean(touched.type && errors.type)}
                          helperText={touched.type && errors.type}
                          label="Select a tax type" />
                      )}
                      getOptionLabel={(option) => option.name ? option.name : ''}
                    /> */}
                  </Stack>

                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                      {editId ? 'Save Changes' : 'Add Payment Terms'}
                    </LoadingButton>
                    <Button variant="outlined" onClick={()=>{setOpenModel(false); formik.resetForm(); setEditId(null); setEditData(null)}} sx={{ marginLeft: '10px' }}>
                      Cancel
                    </Button>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Modal>
      <Dialog open={openCloseConfirm} onClose={() => setOpenCloseConfirm(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Close without saving?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this payment term before closing?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmNo} variant="outlined" color="primary">
            No, Close
          </Button>
          <Button onClick={handleCloseConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationPopup
        open={openDeletePop}
        handleClose={()=>{setOpenDeletePop(false)}}
        message={`You want to delete ${deletingName} ! `}
        handleClick={()=>{handleDeleteClick(deletingId, 2)}}
      />
    </Page>
  );
}
